<div class="notification-settings-items">
  <ul class="list-group list-group-flush">
    <li class="notification-settings-item__single-item list-group-item" *ngFor="let item of settingsItems">
      <h6 class="notification-settings-item__title">{{ item.title }}</h6>
      <app-button-switch [isChecked]="item.active" (changeState)="onChangeState($event, item)"></app-button-switch>
    </li>
  </ul>
</div>
